document.addEventListener('click', function(e) {
  var target = e.target.closest('button, a');
  if (!target) return;
  
  var text = target.innerText ? target.innerText.toLowerCase() : '';
  var id = target.id || '';
  var className = String(target.className || '');
  
  if (target.closest('#shopify-privacy-banner-container, .shopify-privacy-banner, #shopify-pc__banner, .shopify-pc__banner, .shopify-cleanslate')) {
    if (text.indexOf('accept') !== -1 || id.indexOf('accept') !== -1 || className.indexOf('accept') !== -1) {
      e.preventDefault();
      e.stopPropagation();
      document.cookie = 'tracking_consent=true; path=/; max-age=31536000';
      document.cookie = '_tracking_consent=%7B%22v%22%3A%222.1%22%2C%22reg%22%3A%22%22%2C%22con%22%3A%7B%22CMP%22%3A%7B%22a%22%3A%221%22%2C%22m%22%3A%221%22%2C%22p%22%3A%221%22%2C%22s%22%3A%221%22%7D%7D%7D; path=/; max-age=31536000';
      hideBanner(target);
    } else if (text.indexOf('decline') !== -1 || id.indexOf('decline') !== -1 || className.indexOf('decline') !== -1) {
      e.preventDefault();
      e.stopPropagation();
      document.cookie = 'tracking_consent=false; path=/; max-age=31536000';
      document.cookie = '_tracking_consent=%7B%22v%22%3A%222.1%22%2C%22reg%22%3A%22%22%2C%22con%22%3A%7B%22CMP%22%3A%7B%22a%22%3A%220%22%2C%22m%22%3A%220%22%2C%22p%22%3A%220%22%2C%22s%22%3A%220%22%7D%7D%7D; path=/; max-age=31536000';
      hideBanner(target);
    } else if (text.indexOf('manage') !== -1 || id.indexOf('manage') !== -1 || className.indexOf('manage') !== -1) {
      e.preventDefault();
      e.stopPropagation();
      hideBanner(target);
    }
  }
  
  function hideBanner(el) {
    var banner = el.closest('#shopify-privacy-banner-container') || 
                 el.closest('.shopify-privacy-banner') || 
                 el.closest('#shopify-pc__banner') ||
                 el.closest('.shopify-cleanslate');
    if (banner) {
      banner.style.setProperty('display', 'none', 'important');
    }
    var style = document.createElement('style');
    style.innerHTML = '#shopify-privacy-banner-container, .shopify-privacy-banner, #shopify-pc__banner, .shopify-cleanslate { display: none !important; }';
    document.head.appendChild(style);
  }
}, true);
